import axios from '../utils/requset';

const community = {
    // 民政社区
    getCommunity(params) {
        return axios.get("/service-admin/driver/getCommunity/news", { params });
    },
    // 生活服务周边生活圈统计
    getCommunityAround(params) {
        return axios.get("/service-admin/server/getCommunity/around", { params });
    },
    // 生活服务周边线上服务统计
    getAroundService(params) {
        return axios.get("/service-admin/server/getCommunity/around/service", { params });
    },
    // 康养活动列表
    getKyActivityList(params) {
        return axios.get("/service-admin/server/activity", { params });
    },
    // 康养服务列表
    getKyServiceList(params) {
        return axios.get("/service-admin/server/server", { params });
    },
    // 小区信息查询
    getCommunityInfo(params) {
        return axios.get("/service-admin/community/driver/home/", { params });
    },
    // 康养中心
    getKyCenter(params) {
        return axios.get("/service-admin/server/", { params });
    },
}

export default community;